import { render, staticRenderFns } from "./SupplierRestrictionLevelNotif.vue?vue&type=template&id=41373f7e&"
import script from "./SupplierRestrictionLevelNotif.vue?vue&type=script&lang=js&"
export * from "./SupplierRestrictionLevelNotif.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports